export enum DataSecurityMonitorType {
	Personal = 0,
	NewObjectAndFieldAccess = 1,
	Uptime = 2,
	NewUser = 3,
	NewApp = 4,
	SetupAuditTrail = 5,
	Following = 6,
	TimelineSummary = 7,
	ConfigurableFieldAccess = 8,
}
